module.exports = __webpack_public_path__ + "img/play_pause.83b337a9.svg";